@let chat = chats$ | async;
<!--@let messages = messages$ | async;-->
@let isOpened = isOpened$ | async;
@let sharedLoading = sharedLoading$ | async;

<app-top-bar [isBack]="!orderId" customLocation="/chat-list" [title]="'Спеціаліст підтримки 838'"></app-top-bar>
<div class="support-chat-container">
  @if (messages?.length && !messageLoading) {
    @if (isOpened) {
      <div class="close-container default-background">
        <div class="close-ticket main-background-color" (click)="openReason('close')">
          <mat-icon class="default-color">close</mat-icon>
          <div class="close-ticket-text default-color">Завершити звернення</div>
        </div>
      </div>
    }
    <div class="chat"
         [ngStyle]="{'padding-bottom': isRelaxTime ? '0' : '16px'}"
         infiniteScroll
         [infiniteScrollUpDistance]="1"
         [infiniteScrollThrottle]="150"
         (scrolledUp)="onScrollUp()"
         [scrollWindow]="false"
         supportScrollDirective
         id="chatContent">
      @for (chat of messages; track $index) {
        @switch (chat.type) {
          @case ('customer_initial') {
            <div class="customer-message block-background main-text-color">
              @if (chat?.files?.length) {
                <div class="attached-files">
                  @for (file of chat.files; track file) {
                    @switch (file.file_type) {
                      @case ('image') {
                        <img class="image_chat"
                             (click)="openGallery(chat.files)"
                             [src]="file.url" alt="image" />
                      }
                      @case ('video') {
                        <div class="video_chat_container">
                          <img class="video_chat"
                               (click)="openGallery(chat.files)"
                               [src]="file.url | thumb" alt="video" />
                          <mat-icon class="accent-color video-icon">videocam</mat-icon>
                        </div>
                      }
                    }
                  }
                </div>
              }
              @if (chat.message) {
                <div [innerHTML]="chat.message | safe: 'html'" ></div>
              }
              <div class="time">
                {{ chat.created_at | date: 'HH:mm' }}
              </div>
            </div>
          }
          @case ('system_message') {
            <div class="support-message default-color">
              @if (chat?.files?.length) {
                <div class="attached-files">
                  @for (file of chat.files; track file) {
                    @switch (file.file_type) {
                      @case ('image') {
                        <img class="image_chat"
                             (click)="openGallery(chat.files)"
                             [src]="file.url" alt="image" />
                      }
                      @case ('video') {
                        <div class="video_chat_container">
                          <img class="video_chat"
                               (click)="openGallery(chat.files)"
                               [src]="file.url | thumb" alt="video" />
                          <mat-icon class="accent-color video-icon">videocam</mat-icon>
                        </div>
                      }
                    }
                  }
                </div>
              }
              <mat-icon class="accent-color-background icon-headphone default-color">headset_mic</mat-icon>
              <div class="support-message-text accent-color-background">
                @if (chat.message) {
                  <div [innerHTML]="chat.message | safe: 'html'" ></div>
                }
                <div class="time">
                  {{ chat.created_at | date: 'HH:mm' }}
                </div>
              </div>
            </div>
          }
          @case ('customer_reply') {
            <div class="customer-message block-background main-text-color">
              @if (chat?.files?.length) {
                <div class="attached-files">
                  @for (file of chat.files; track file) {
                    @switch (file.file_type) {
                      @case ('image') {
                        <img class="image_chat"
                             (click)="openGallery(chat.files)"
                             [src]="file.url"
                             alt="image" />
                      }
                      @case ('video') {
                        <div class="video_chat_container">
                          <img class="video_chat"
                               (click)="openGallery(chat.files)"
                               [src]="file.url | thumb" alt="video" />
                          <mat-icon class="accent-color video-icon">videocam</mat-icon>
                        </div>
                      }
                    }
                  }
                </div>
              }
              @if (chat.message) {
                <div [innerHTML]="chat.message | safe: 'html'" ></div>
              }
              <div class="time">
                {{ chat.created_at | date: 'HH:mm' }}
              </div>
            </div>
          }
          @case ('operator_reply') {
            <div class="support-message default-color">
              <mat-icon class="accent-color-background icon-headphone default-color">headset_mic</mat-icon>
              <div class="support-message-text accent-color-background">
                @if (chat?.files?.length) {
                  <div class="attached-files">
                    @for (file of chat.files; track file) {
                      @switch (file.file_type) {
                        @case ('image') {
                          <img class="image_chat"
                               (click)="openGallery(chat.files)"
                               [src]="file.url" alt="image" />
                        }
                        @case ('video') {
                          <div class="video_chat_container">
                            <img class="video_chat"
                                 (click)="openGallery(chat.files)"
                                 [src]="file.url | thumb" alt="video" />
                            <mat-icon class="accent-color video-icon">videocam</mat-icon>
                          </div>
                        }
                      }
                    }
                  </div>
                }
                @if (chat.message) {
                  <div [innerHTML]="chat.message | safe: 'html'" ></div>
                }
                <div class="time">
                  {{ chat.created_at | date: 'HH:mm' }}
                </div>
              </div>
            </div>
          }
        }
      }
    </div>
  } @else if (!messages?.length && !messageLoading) {
    <div class="progress-custom">
      <div class="spinner-text main-text-color">{{'Повідомлень немає'}}</div>
    </div>
  } @else {
    <div class="progress-custom">
      <mat-spinner class="progress-spinner"></mat-spinner>
      <div class="spinner-text main-text-color">{{'Завантаження повідомлень'}}</div>
    </div>
  }
  @if (isOpened) {
    @if (isRelaxTime && !messageLoading) {
      <div class="time-message hint-color">Ми на зв’язку в будні з 9:00 до 18:00</div>
    }
    <div class="input-chat-block block-background"
         [ngClass]="{'input-chat-block-resize': vcr()?.get(0)}"
         [formGroup]="messageForm"
    >
      <div class="attached-files">
        <ng-container #container></ng-container>
      </div>
      <div class="input-line">
        <div class="message-form-field pseudo-button"
             [ngStyle]="{'opacity': components.length === 3 ? '0.5' : '1'}"
             (click)="!vcr()?.get(2) ? openBottomSheet() : null">
          <mat-icon class="accent-color">attach_file</mat-icon>
        </div>
        <mat-form-field class="message-form-field"
                        subscriptSizing="dynamic"
                        appearance="outline">
          <input matInput
                 #messageInput
                 maxlength="1000"
                 formControlName="message"
                 placeholder="Введіть повідомлення" />
          <button mat-icon-button
                  matSuffix
                  (click)="sendMessage()"
                  [disabled]="(!messageInput.value && !components.length) || sendLoading || sharedLoading"
                  [ngStyle]="{'opacity': (!messageInput.value && !components.length) || sendLoading || sharedLoading ? '0.5' : '1'}"
          >
            <mat-icon class="accent-color">send</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  } @else {
    <div class="closed-block">
      <div class="inner-closed-block done-background">
        <div class="info-block done-color">
          <mat-icon class="check">check</mat-icon>
          <div class="info-main-text done-color">Ваше звернення опрацьовано та закрито. Залишились додаткові запитання?</div>
        </div>
        <div class="button-block main-text-color">
          <button class="main-button negative-button button-border-color-inversion button-text-color button-text-background"
                  [disableRipple]="true"
                  (click)="openReason('reopen')"
                  mat-stroked-button>Потрібна допомога
          </button>
        </div>
      </div>
    </div>
  }
</div>

@if (items?.length) {
  <div class="gallery-container">
    <button mat-mini-fab
            (click)="closeGallery()"
            class="close-gallery-button">
      <mat-icon>close</mat-icon>
    </button>
    @if (items && items?.length) {
      <gallery style="height: 100dvh;" [items]="items"></gallery>
    }
  </div>
}
